import React from "react";
import { Button } from "reactstrap";

/**
 * Transforms a single platform item with action buttons
 * @param {Object} platform - Platform object from API
 * @param {Function} onEdit - Edit handler function
 * @param {Function} onToken - Token handler function
 * @param {Function} onDelete - Delete handler function
 * @returns {Object} Transformed platform object with action buttons
 */
export const transformPlatformItem = (platform, onEdit, onToken, onDelete) => ({
    ...platform,
    action: (
        <span>
            <Button
                color="success"
                onClick={() => onEdit(platform.id, platform.name, platform.email, platform.username)}
                className="btn btn-primary waves-effect waves-light"
                data-toggle="modal"
                data-target="#myModal"
            >
                Edit
            </Button>
            &nbsp;&nbsp;
            <Button
                color="primary"
                onClick={() => onToken(platform.email)}
                className="btn btn-primary waves-effect waves-light"
                data-toggle="modal"
                data-target="#myModal"
            >
                Token
            </Button>
            &nbsp;&nbsp;
            <Button
                color="danger"
                onClick={() => onDelete(platform.id)}
                className="btn btn-danger waves-effect waves-light"
                data-toggle="modal"
                data-target="#myModal"
            >
                Delete
            </Button>
        </span>
    )
});

/**
 * Transforms array of platforms into DataTable format
 * @param {Array} platforms - Array of platform objects from API
 * @param {Array} columns - Table column configuration
 * @param {Function} onEdit - Edit handler function
 * @param {Function} onToken - Token handler function
 * @param {Function} onDelete - Delete handler function
 * @returns {Object} DataTable formatted object with columns and rows
 */
export const transformPlatformsToTableData = (platforms, columns, onEdit, onToken, onDelete) => {
    const rows = platforms.map(platform => transformPlatformItem(platform, onEdit, onToken, onDelete));

    return {
        columns,
        rows
    };
};

